import { Box, Typography } from "@mui/material";
import ProgressIndicator from "../../../components/ProgressIndicator";
import { useStyles } from "../styles/SubscriptionSection.styles";

interface SubscriptionSectionProps {
  title: string;
  mainValue: string | number;
  secondaryText?: string;
  showProgress?: boolean;
  progressPercent?: number;
  isItalic?: boolean;
  children?: React.ReactNode;
}

const SubscriptionSection: React.FC<SubscriptionSectionProps> = ({
  title,
  mainValue,
  secondaryText,
  showProgress = false,
  progressPercent = 0,
  isItalic = false,
  children,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.sectionContainer}>
      <Box className={classes.upperSectionContainer}>
        <Typography className={classes.mainText}>{title}</Typography>
        <Box className={classes.indicatorTextContainer}>
          <Typography
            className={isItalic ? classes.italicIndicatorText : classes.indicatorText}
          >
            {mainValue}
          </Typography>
          {showProgress && <ProgressIndicator progressInPercent={progressPercent} />}
        </Box>
      </Box>
      <Box className={classes.sectionDivider} />
      {secondaryText && (
        <Typography className={classes.secondaryText}>{secondaryText}</Typography>
      )}
      {children}
    </Box>
  );
};

export default SubscriptionSection;
